import type { ReactNode, SVGProps } from "react";

export function SettingsIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="18"
			viewBox="0 0 15 18"
			width="15"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_503_1714)">
				<path
					d="M6.24375 3.23775C6.56325 1.92075 8.43675 1.92075 8.75625 3.23775C8.80419 3.4356 8.89816 3.61933 9.03053 3.774C9.1629 3.92867 9.32992 4.04989 9.51799 4.12781C9.70606 4.20573 9.90987 4.23814 10.1128 4.2224C10.3158 4.20667 10.5122 4.14323 10.686 4.03725C11.8432 3.33225 13.1685 4.65675 12.4635 5.81475C12.3577 5.98849 12.2943 6.18475 12.2786 6.38758C12.2629 6.59041 12.2953 6.79408 12.3731 6.98203C12.451 7.16999 12.5721 7.33693 12.7265 7.46929C12.881 7.60164 13.0646 7.69568 13.2622 7.74375C14.5792 8.06325 14.5792 9.93675 13.2622 10.2563C13.0644 10.3042 12.8807 10.3982 12.726 10.5305C12.5713 10.6629 12.4501 10.8299 12.3722 11.018C12.2943 11.2061 12.2619 11.4099 12.2776 11.6128C12.2933 11.8158 12.3568 12.0122 12.4627 12.186C13.1677 13.3432 11.8432 14.6685 10.6852 13.9635C10.5115 13.8577 10.3152 13.7943 10.1124 13.7786C9.90959 13.7629 9.70592 13.7953 9.51796 13.8731C9.33001 13.951 9.16307 14.0721 9.03071 14.2265C8.89835 14.381 8.80432 14.5646 8.75625 14.7623C8.43675 16.0793 6.56325 16.0793 6.24375 14.7623C6.19581 14.5644 6.10183 14.3807 5.96947 14.226C5.8371 14.0713 5.67008 13.9501 5.48201 13.8722C5.29394 13.7943 5.09013 13.7619 4.88716 13.7776C4.6842 13.7933 4.48781 13.8568 4.314 13.9628C3.15675 14.6678 1.8315 13.3432 2.5365 12.1852C2.64233 12.0115 2.70566 11.8152 2.72136 11.6124C2.73706 11.4096 2.70468 11.2059 2.62685 11.018C2.54903 10.83 2.42795 10.6631 2.27345 10.5307C2.11896 10.3984 1.93542 10.3043 1.73775 10.2563C0.42075 9.93675 0.42075 8.06325 1.73775 7.74375C1.9356 7.69581 2.11933 7.60183 2.274 7.46947C2.42867 7.3371 2.54989 7.17008 2.62781 6.98201C2.70573 6.79394 2.73814 6.59013 2.7224 6.38716C2.70667 6.1842 2.64323 5.98781 2.53725 5.814C1.83225 4.65675 3.15675 3.3315 4.31475 4.0365C5.06475 4.4925 6.03675 4.089 6.24375 3.23775Z"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.25"
				/>
				<path
					d="M5.25 9C5.25 9.59674 5.48705 10.169 5.90901 10.591C6.33097 11.0129 6.90326 11.25 7.5 11.25C8.09674 11.25 8.66903 11.0129 9.09099 10.591C9.51295 10.169 9.75 9.59674 9.75 9C9.75 8.40326 9.51295 7.83097 9.09099 7.40901C8.66903 6.98705 8.09674 6.75 7.5 6.75C6.90326 6.75 6.33097 6.98705 5.90901 7.40901C5.48705 7.83097 5.25 8.40326 5.25 9Z"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.25"
				/>
			</g>
			<defs>
				<clipPath id="clip0_503_1714">
					<rect fill="transparent" height="18" width="15" />
				</clipPath>
			</defs>
		</svg>
	);
}
